import { ColorState } from './types';

export const state = (): ColorState => initialState();

export const initialState = (): ColorState => ({
  colors: {
    //TODO remove when was made backend
    items: [],
    isLoading: false,
    total: 0, //TODO remove when was made backend
    searchParams: {
      dataOption: {
        page: 1,
        itemsPerPage: 50,
        sortBy: [],
        sortDesc: [false],
        groupBy: [],
        groupDesc: [],
        multiSort: true,
        mustSort: false,
      },
      filter: '',
      orClauseFieldsIds: ['ActionEmailMessage'],
    },
  },
});
